import * as React from "react";
import {
    TextField,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    IconButton,
    Checkbox,
    FormControlLabel,
} from "@mui/material";
import { getContractPdc, addVoucher } from "state/apis";
import { Close as CloseIcon } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { toast } from "react-toastify";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { add } from "dayjs";
import { useNavigate } from "react-router-dom";

export default function Voucher({ open, onClose, editData, editMode, banks, onSubmit }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [fetchCheque, setFetchCheque] = React.useState(false);
    // console.log("fetchCheque: ", fetchCheque);
    const [input, setInput] = React.useState({ pdc: [] });
    const [payload, setPayload] = React.useState({
        contractId: editData.id,
        date: "",
        note: "",
        totalAmount: 0,
        receipts: [],
        isManual: false,
    });
    let total = 0;

    // React.useEffect(() => {
    //     const fetchData = async () => {
    //         if (editMode && editData) {
    //             try {
    //                 const res = await getContractPdc(editData.id);
    //                 const updatedData = res?.data.map((val) => ({
    //                     id: val?.id,
    //                     note: val?.chequeSerialNumber,
    //                     date: val?.chequeDate,
    //                     particulars: val?.banks?.name,
    //                     amount: val?.amount,
    //                 }));
    //                 setData(updatedData);
    //                 setPayload((prevData) => ({
    //                     ...prevData,
    //                     contractId: editData.id,
    //                 }));
    //             } catch (error) {
    //                 console.error("Error fetching data:", error);
    //             }
    //         } else {
    //             setData([]);
    //         }
    //     };

    //     fetchData();
    //     // }, [editData, editMode]);
    // }, [fetchCheque === true]);

    const fetchChequeData = async () => {
        try {
            const res = await getContractPdc(editData.id);
            const updatedData = res?.data.map((val) => ({
                id: val?.id,
                note: val?.chequeSerialNumber,
                date: val?.chequeDate,
                particulars: val?.banks?.name,
                amount: val?.amount,
            }));
            setData((prevData) => {
                const manuallyAddedItems = prevData.filter((item) => !item.id);
                return [...manuallyAddedItems, ...updatedData];
            });
            setPayload((prevData) => ({
                ...prevData,
                contractId: editData.id,
            }));
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    React.useEffect(() => {
        if (fetchCheque) {
            fetchChequeData();
            setFetchCheque(false);
        }
    }, [fetchCheque]);
    const handleChangeDate = (date) => {
        const formattedDate = date.format("YYYY-MM-DD");
        setPayload((prevData) => {
            return {
                ...prevData,
                date: formattedDate,
            };
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setPayload((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleAddPdc = () => {
        setInput((prevData) => ({
            ...prevData,
            pdc: [...prevData.pdc, { note: "", date: "", particulars: "", amount: "" }],
        }));
    };
    const handleSave = () => {
        setData((preData) => [...preData, ...input.pdc]);
        setInput({ pdc: [] });
    };

    const handlePdcChange = (index, key, value) => {
        setInput((prevData) => {
            const updatedPdc = prevData.pdc.map((item, idx) => {
                if (idx === index && Object.keys(item).includes(key)) {
                    return {
                        ...item,
                        [key]: value,
                    };
                }
                return item;
            });

            return {
                ...prevData,
                pdc: updatedPdc,
            };
        });
    };

    const handleCancelPdc = (indexToRemove) => {
        setInput((prevState) => ({
            ...prevState,
            pdc: prevState.pdc.filter((_, index) => index !== indexToRemove),
        }));
    };

    const handleSubmit = async () => {
        try {
            const newPayload = {
                ...payload,
                receipts: data,
                totalAmount: total,
            };

            // Call the API with the updated payload
            const response = await addVoucher(newPayload);
            toast.success(response.message);

            onSubmit();
            onClose();
            navigate("/voucher receipts");
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    const handleDeleteClick = (row) => {
        const updatedData = data.filter((item, index) => index !== row);
        setData(updatedData);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"md"}>
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                Receipt Voucher
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} my={"8px"}>
                    <Grid item xs={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                            <DatePicker
                                fullWidth
                                label="Select date"
                                name="date"
                                onChange={handleChangeDate}
                                value={payload.date ? dayjs(payload.date) : null}
                                format="DD/MM/YYYY"
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Note"
                            name="note"
                            value={payload?.note}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={payload.isManual}
                                    onChange={(e) =>
                                        setPayload({
                                            ...payload,
                                            isManual: e.target.checked,
                                        })
                                    }
                                    name="isManual"
                                    color="primary"
                                />
                            }
                            label="Manual"
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            variant="contained"
                            onClick={() => setFetchCheque(true)}
                            sx={{
                                color: theme.palette.primary.light,
                                backgroundColor: theme.palette.secondary[200],
                            }}
                        >
                            Add Cheques
                        </Button>
                    </Grid>
                </Grid>
                <Grid
                    item
                    xs={12}
                    border={1}
                    p={2}
                    // m={3}
                    mb={1}
                    mr={0}
                    borderRadius={1}
                    sx={{ borderColor: "grey.400" }}
                >
                    <Grid container alignItems="center" mb={2}>
                        <Grid item xs={10}>
                            <label style={{ color: theme.palette.grey[600] }}>Item</label>
                        </Grid>
                        <Grid item xs={2} container justifyContent="flex-end">
                            <Button variant="contained" onClick={handleAddPdc}>
                                Add Items
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        {input?.pdc.map((val, index) => (
                            <Grid container spacing={2} key={index} mb={2}>
                                <Grid item xs={5}>
                                    <TextField
                                        fullWidth
                                        color="primary"
                                        label="Particulars"
                                        value={val.particulars}
                                        onChange={(e) =>
                                            handlePdcChange(index, "particulars", e.target.value)
                                        }
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        type="number"
                                        fullWidth
                                        color="primary"
                                        label="Amount"
                                        value={val.amount}
                                        onChange={(e) =>
                                            handlePdcChange(index, "amount", e.target.value)
                                        }
                                    />
                                </Grid>
                                <Grid item xs={1} container justify="end" margin="auto">
                                    <IconButton
                                        color="error"
                                        onClick={() => handleCancelPdc(index)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        ))}

                        {input?.pdc.length > 0 && (
                            <Grid container justifyContent="flex-end" mt={2}>
                                <Button variant="contained" color="primary" onClick={handleSave}>
                                    Save
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>

                <TableContainer
                    sx={{ overflowX: "auto", marginBottom: theme.spacing(2), maxHeight: 900 }}
                >
                    <Table
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ backgroundColor: "#fff" }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Sr No
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Note
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Date
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Particulars
                                </TableCell>
                                <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Amount
                                </TableCell>
                                <TableCell
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#5a6a85",
                                    }}
                                >
                                    Action
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.length ? (
                                data.map((row, index) => {
                                    total += parseInt(row.amount); // Increment total outside the JSX
                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{row?.note}</TableCell>
                                            <TableCell>
                                                {row.date
                                                    ? moment(row?.date).format("DD/MM/YYYY")
                                                    : ""}
                                            </TableCell>
                                            <TableCell>{row?.particulars}</TableCell>
                                            <TableCell>{row?.amount}</TableCell>
                                            <TableCell>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => handleDeleteClick(index)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow>
                                    <TableCell
                                        colSpan={6}
                                        sx={{ textAlign: "center", fontWeight: "700", mb: "2px" }}
                                    >
                                        No data found
                                    </TableCell>
                                </TableRow>
                            )}
                            {data.length > 0 && (
                                <TableRow hover role="checkbox">
                                    <TableCell colSpan={"4"} sx={{ textAlign: "end" }}>
                                        Total
                                    </TableCell>
                                    <TableCell>{total}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Grid container justifyContent="flex-end" my={2}>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Save
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
